import { Box, Button, Dialog, DialogActions, DialogTitle, FormControl, TextField } from "@mui/material";
import { CaseDisplayGroup } from "generated/graphql";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useAppDispatch } from "redux/hooks";
import { updateCaseDisplayGroups } from "redux/slices/lensEditor";

export default function EditCaseDisplayGroupDialog({
  open,
  close,
  caseDisplayGroup,
  lensId,
}: {
  open: boolean;
  close: () => void;
  lensId: number;
  caseDisplayGroup: CaseDisplayGroup;
}) {
  const [name, setName] = useState(caseDisplayGroup.name);
  const [description, setDescription] = useState(caseDisplayGroup.description);
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const save = async () => {
    try {
      await dispatch(
        updateCaseDisplayGroups({
          lensId,
          groups: [
            {
              id: caseDisplayGroup.id,
              name,
              description: description || null,
              columns: caseDisplayGroup.columns,
              rows: caseDisplayGroup.rows,
            },
          ],
        })
      ).unwrap();
      enqueueSnackbar("Case display group updated", { variant: "success" });
      close();
    } catch (e) {
      console.error(e);
      enqueueSnackbar("Unable to update case display group", { variant: "error" });
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>Edit Case Display Group</DialogTitle>
      <Box sx={{ px: 2, mt: 1, mb: 2, display: "flex", gap: 1, flexDirection: "column" }}>
        <FormControl fullWidth>
          <TextField
            helperText={`${name.length}/64 characters`}
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value.slice(0, 64))}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
          />
        </FormControl>
      </Box>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={save} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
